export default "__VITE_ASSET__BrEXKsWz__"